/**
 *  使用方法 import audioPlayer from '../utils/AudioPlayer';
 *  audioPlayer.toggle(url);
 *  audioPlayer.close();
 * */

class AudioPlayer {
  constructor() {
    var ua = navigator.userAgent.toLowerCase();

    this.audiodom = document.createElement("audio");
    this.upUrl = "";
    if (/iphone|ipad|ipod/.test(ua)) {
      this.prefix = '.mp3';
    } else {
      this.prefix = '';
    }
  }

  //用来控制 同一个音乐的播放暂停;
  toggle(src) {
    if (!src && this.upUrl === "") {
      throw new Error("src is not exist");
    }
    if (this.audiodom.paused) {
      if (this.upUrl === src) {
        this.play();
      } else {
        this.play(src);
      }
    } else {
      if (this.upUrl !== src){
        this.play(src);
      }else{
        this.parse();
      }
    }
    if (src) {
      this.upUrl = src;
    }
  }

  playStatus() {
    return this.audiodom.paused;
  }

  //播放一个音乐，  不传参数就是恢复播放
  play(src) {
    if (src) {
      if (src.indexOf('.mp3') > -1) {
        this.upUrl = src
      } else {
        this.upUrl = src + this.prefix;
      }

      this.audiodom.src = this.upUrl;
      this.audiodom.load();
    } else {
      if (!this.upUrl) {
        throw new Error("音乐未播放过，不能直接恢复。");
      }
    }
    this.audiodom.play();
  }

  parse() {
    this.audiodom.pause();
  }
  //关闭音乐播放器，停止音乐
  close() {
    this.parse();
    this.upUrl = "";
  }
}

var audioPlayer = new AudioPlayer();
export default audioPlayer



// WEBPACK FOOTER //
// ./src/utils/AudioPlayer.js